import { FC } from 'react';
import { SkeletonLoadingTypeProps, SkeletonLoadingTheme } from './TypeProps';
import classNames from 'classnames';

import styles from './SkeletonLoading.module.scss';

export const SkeletonLoading: FC<SkeletonLoadingTypeProps> = ({ width, height, className, theme = SkeletonLoadingTheme.Theme1 }) => {
  return <div style={{ width, height }} className={classNames(styles.WrapperSkeletonLoading, styles[theme], className)} />;
};
